import styled from "styled-components"

import {Hr} from "@irati/ui/src/Layout"
import {minWidthMedia} from "@irati/ui/src/global/media"
import padding from "@irati/ui/src/global/padding"

export const StyledHr = styled(Hr)`
  ${minWidthMedia.tablet`
    margin-top: ${padding.base}
  `}
`
